import type { BlockDefinition } from '../types';
import { storyScrollytellingSchema, type StoryScrollytellingData } from './schema';
import { StoryScrollytellingRenderer } from './Renderer.client';

export const storyScrollytellingBlock: BlockDefinition<StoryScrollytellingData> = {
  meta: {
    type: 'story-scrollytelling',
    label: 'Story scrollytelling (v5)',
    description: 'Sección sticky con vídeo a la izquierda y 4+ capítulos a la derecha que cambian al hacer scroll.',
    category: 'content',
    icon: 'film',
  },
  schema: storyScrollytellingSchema,
  defaults: {
    eyebrow: '● Quiénes somos · 4 capítulos',
    title: 'Personas, método y',
    titleHl: '17 años detrás de cada operación.',
    subtitle: 'Un equipo propio que ha cerrado +120 operaciones desde 2009. Sin intermediarios, sin freelancers.',
    linkLabel: 'Conoce al equipo completo',
    linkHref: '/sobre-nosotros',
    videoPoster: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=1600&h=1100&fit=crop&q=85&auto=format',
    videoPosterFallback: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=1600&h=1100&fit=crop&q=85&auto=format',
    videoAlt: 'Equipo en sesión de trabajo',
    videoCaption: {
      title: 'El equipo, en primera persona',
      sub: 'Socios y consejo · sesión de trabajo interna',
    },
    chapters: [
      {
        badge: 'Capítulo 01 · El equipo',
        eyebrow: 'Capítulo 01 — El equipo',
        bigValue: '+30',
        bigUnit: 'profesionales',
        title: 'Equipo sénior propio. Tú hablas siempre con quien decide.',
        description: 'Socios y directores con +15 años de media en banca de inversión, M&A y aceleración.',
        meta: ['Equipo propio', '0% freelancers'],
      },
      {
        badge: 'Capítulo 02 · Trayectoria',
        eyebrow: 'Capítulo 02 — Trayectoria',
        bigValue: '17',
        bigUnit: 'años',
        title: 'Sin interrupciones desde 2009.',
        description: 'Hemos operado durante crisis financieras, booms tecnológicos y reinvenciones del mercado.',
        meta: ['Fundación 2009', '4 oficinas activas'],
      },
      {
        badge: 'Capítulo 03 · Modelo dual',
        eyebrow: 'Capítulo 03 — Modelo dual',
        bigValue: '2',
        bigUnit: 'líneas',
        title: 'Aceleradora + compraventa M&A bajo una sola marca.',
        description: 'El único grupo en España que cubre el ciclo entero: del primer cheque hasta la transmisión.',
        meta: ['Pre-seed a Serie A', 'M&A · €0,5M – €25M'],
      },
      {
        badge: 'Capítulo 04 · Confidencialidad',
        eyebrow: 'Capítulo 04 — Confidencialidad',
        bigValue: '100',
        bigUnit: '%',
        title: 'NDA desde el primer correo. Discreción no negociable.',
        description: 'Procesos compartimentados, comunicación cifrada y data-room virtual.',
        meta: ['NDA primer contacto', 'Data-room cifrado'],
      },
    ],
  },
  fields: [
    { name: 'eyebrow', label: 'Eyebrow', type: 'text', max: 120 },
    { name: 'title', label: 'Título', type: 'text', required: true, max: 200 },
    { name: 'titleHl', label: 'Título highlight', type: 'text', max: 160 },
    { name: 'subtitle', label: 'Subtítulo', type: 'textarea', max: 500 },
    { name: 'linkLabel', label: 'Link inferior texto', type: 'text', max: 80 },
    { name: 'linkHref', label: 'Link inferior URL', type: 'url' },
    { name: 'videoPoster', label: 'Poster vídeo', type: 'image', required: true },
    { name: 'videoPosterFallback', label: 'Poster vídeo (fallback)', type: 'image' },
    { name: 'videoAlt', label: 'Alt vídeo', type: 'text', max: 200 },
    {
      name: 'videoCaption',
      label: 'Caption vídeo',
      type: 'object',
      fields: [
        { name: 'title', label: 'Título', type: 'text', required: true, max: 160 },
        { name: 'sub', label: 'Subtítulo', type: 'text', required: true, max: 200 },
      ],
    },
    {
      name: 'chapters',
      label: 'Capítulos (2-6)',
      type: 'array',
      max: 6,
      itemFields: [
        { name: 'badge', label: 'Badge en vídeo', type: 'text', required: true, max: 80 },
        { name: 'eyebrow', label: 'Eyebrow card', type: 'text', required: true, max: 120 },
        { name: 'bigValue', label: 'Número grande', type: 'text', required: true, max: 60 },
        { name: 'bigUnit', label: 'Unidad', type: 'text', max: 40 },
        { name: 'title', label: 'Título', type: 'text', required: true, max: 200 },
        { name: 'description', label: 'Descripción', type: 'textarea', required: true, max: 600 },
      ],
    },
  ],
  Renderer: StoryScrollytellingRenderer,
};

export { storyScrollytellingSchema, StoryScrollytellingRenderer };
export type { StoryScrollytellingData };
